/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_TenantInputs */

const cs_property_legal_tenant = /** @type {(inputs: Property_Legal_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nájemce`)
};

const en_property_legal_tenant = /** @type {(inputs: Property_Legal_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant`)
};

/**
* | output |
* | --- |
* | "Tenant" |
*
* @param {Property_Legal_TenantInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_tenant = /** @type {((inputs?: Property_Legal_TenantInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_TenantInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_tenant(inputs)
	return cs_property_legal_tenant(inputs)
});